// URL slugs for portfolio models, e.g. /work/chemical-reactor
// Derived from each model's display name. Set `slug: "..."` on a model in models.js to override.

export function slugify(text) {
    return String(text)
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
}

export function projectSlug(p) {
    if (p.slug) return p.slug;
    const base = slugify(p.name);
    return p.group === "Model Mania" ? `model-mania-${base}` : base;
}

export const SITE_URL = "https://www.ibrahimtayyab.com";

export function projectPath(p) {
    return `/work/${projectSlug(p)}`;
}
